import Overlay from "../_overlay/_overlay.js";

class Search extends Overlay {
  /**
   * @param {boolean} isOpen
   */
  onToggle(isOpen) {
    this.callback("search", isOpen);
  }
}

export default Search;
